// removed by extract-text-webpack-plugin
module.exports = {"Rules":"Rule__Rules__14pfc","Rule":"Rule__Rule__3b0Ol"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Rule/Rule.css
// module id = 365
// module chunks = 0